module.exports = __webpack_public_path__ + "img/icon_sqys.4c775162.png";